import { Phone, Send, Mail, MessageSquare } from 'lucide-react';

// Shared logic to turn a contact (type + value) into a tappable href so mobile
// users can call / message / email in one tap. Used across EventCard, HostAction,
// host-shared contacts, etc.
export function contactHref(type, value) {
  const v = (value || '').trim();
  if (!v) return null;
  const ty = (type || '').toLowerCase();
  if (ty === 'email') return `mailto:${v}`;
  if (ty === 'phone' || ty === 'gsm') return `tel:${v.replace(/[^\d+]/g, '')}`;
  if (ty === 'whatsapp') return `https://wa.me/${v.replace(/[^\d]/g, '')}`;
  if (ty === 'telegram') {
    const handle = v.replace(/^@/, '').replace(/^https?:\/\/(t\.me|telegram\.me)\//i, '');
    return `https://t.me/${handle}`;
  }
  // Bare email-looking value with no explicit type → treat as email.
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return `mailto:${v}`;
  return null;
}

// tel:/mailto: are same-tab (handled by the OS); web links open a new tab.
export function contactLinkProps(href) {
  if (!href) return {};
  const external = /^https?:\/\//i.test(href);
  return external ? { target: '_blank', rel: 'noreferrer' } : {};
}

export function contactIcon(type) {
  const ty = (type || '').toLowerCase();
  if (ty === 'phone' || ty === 'gsm' || ty === 'whatsapp') return Phone;
  if (ty === 'telegram') return Send;
  if (ty === 'email') return Mail;
  return MessageSquare;
}
